<ion-accordion-group class="groups ion-margin-bottom" *transloco="let t; read: 'profileBarComp'">
    <div class="groups-accor-grey">
        <div slot="header">
            <div class="reserved-wrapper">
                <div class="start">
                    <div class="title"> {{ t('group') }}</div>
<!--                    <div class="group-title"> {{ group?.title | transloco }}</div>-->
                    <div class="group-title"> {{ group?.title  }}</div>
                    <div class="date-details-wrapper">
                        <div class="date">
                            <img src="/assets/images/icons/calendar.svg">
                            {{ t('start') }}: {{ group?.start }}
                        </div>

                        <div class="details" (click)="showDetails = !showDetails">
                            {{ t('details') }}
                            <img src="/assets/images/icons/arrow_down_green.svg">
                        </div>

                    </div>


                </div>

                <div class="end" *ngIf="this.hasEmptySeats && !this.hasPaid">


                    <div class="payment">
                        <div>    {{ t('payment') }}: {{ group?.debts?.debt_amount }}{{ t('grn') }}</div>

                        <div class="payment-details">


                                                        <div class="price-popover d-none ">

                                                            <div class="info">
                                                                <div> {{ t('price') }}:</div>
                                                                <div> {{ group?.debts?.debt_amount_course?  group?.debts?.debt_amount_course: '0' }}
                                                                {{ t('grn') }}
                                                                </div>
                                                            </div>
                                                            <div class="info">
                                                                <div>{{ t('material') }}:</div>
                                                                <div>{{ group?.debts?.debt_amount_book?group?.debts?.debt_amount_book : '0' }}  {{ t('grn') }}</div>
                                                            </div>
                                                            <div class="info agreement">
                                                                <div> {{ t('agreement1') }}
                                                                    <a [routerLink]="'/'"  (click)="openUrl(AGREEMENT_LINK)">{{ t('agreement2') }}</a>

                                                                </div>

                                                            </div>


                                                        </div>


                            <img class src="assets/images/icons/info.svg"/>
                        </div>

<!--                        <ion-popover trigger="hover-trigger-{{group?.id}}" triggerAction="hover" class="price-popover" side="top" alignment="center" mode="ios">-->
<!--                            <ng-template>-->
<!--                                <div class="wrapper">-->
<!--                                    <div class="info">-->
<!--                                        <div>Ціна курсу:</div>-->
<!--                                        <div> {{ group?.debts?.debt_amount_course ? group?.debts?.debt_amount_course : '0' }}-->
<!--                                            грн-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div class="info">-->
<!--                                        <div>Матеріали:</div>-->
<!--                                        <div>{{ group?.debts?.debt_amount_book ? group?.debts?.debt_amount_book : '0' }}-->
<!--                                            грн-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div class="info agreement">-->
<!--                                        <div>* ознайомтесь з правилами-->
<!--                                            <a [routerLink]="'/'" (click)="openUrl(AGREEMENT_LINK)">договору публічної-->
<!--                                                офферти</a>-->

<!--                                        </div>-->

<!--                                    </div>-->
<!--                                </div>-->

<!--                            </ng-template>-->
<!--                        </ion-popover>-->

                    </div>


                    <div>

                        <button class="btn green-btn" (click)="goToPay()"> {{ t('toPay') }}</button>
                    </div>
                </div>
                <div class="end" *ngIf="this.hasPaid || !this.hasEmptySeats" [ngClass]="{'width-auto':this.hasPaid }">

                    <div class="reserved-message">
                        {{ t('inReserve') }}

                    </div>
                </div>
            </div>
        </div>
        <div class="list-info" *ngIf="showDetails">
            <ion-list>
                <ion-item>
                    <ion-label class="ion-no-margin">
                        <div class="info">
                            <div class="title">{{ t('level') }}</div>
                            <div class="sub-title ion-align-items-end">
                                <img src="/assets/images/icons/levels.svg" alt="levels">
                                {{ group?.englishLevel }}
                            </div>
                        </div>
                    </ion-label>
                </ion-item>
                <ion-item>
                    <ion-label>
                        <div class="info">
                            <div class="title">{{ t('studyMaterial') }}</div>
                            <div class="sub-title ion-align-items-end">
                                <img src="/assets/images/icons/books.svg" alt="books">
                                {{ group?.educationMaterialTitle }}
                            </div>
                        </div>
                    </ion-label>
                </ion-item>
                <ion-item>
                    <ion-label>
                        <div class="info">
                            <div class="title">{{ t('schedule') }}</div>
                            <div class="sub-title ion-align-items-end">
                                <img src="/assets/images/icons/schedule.svg" alt="calendar">
                                {{ group?.schedule }}
                            </div>
                        </div>
                    </ion-label>
                </ion-item>
                <ion-item *ngIf="group?.holidays">
                    <ion-label>
                        <div class="info">
                            <div class="title">{{ t('holidays') }}</div>
                            <div class="sub-title ion-align-items-end">
                                <img src="/assets/images/icons/holidays.svg" alt="holidays">
                                {{ group?.holidays }}
                            </div>
                        </div>
                    </ion-label>
                </ion-item>
                <ion-item>
                    <ion-label>
                        <div class="info">
                            <div class="title">{{ t('teacher') }}</div>
                            <div class="sub-title ion-align-items-end">
                                <img src="/assets/images/icons/teacher.svg" alt="teacher">
                                {{ group?.teacherName }}
                            </div>
                        </div>
                    </ion-label>
                </ion-item>

                <ion-item>
                    <ion-label>
                        <div class="info">
                            <div class="title">{{ t('address') }}</div>
                            <div class="sub-title  ion-align-items-end">
                                <img src="/assets/images/icons/location.svg" alt="location">
                                {{ group?.address }}
                            </div>
                        </div>
                    </ion-label>
                </ion-item>
            </ion-list>
        </div>
    </div>
</ion-accordion-group>
